module.exports = __webpack_public_path__ + "static/media/pricing_notes.de09c98f.svg";